// /home/labdoo/zitech-nexus/frontend/src/pages/admin/TrainingContentForm.tsx
import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { adminTrainingAPI } from '../../services/api';
import './TrainingContentForm.css';

// SVG Icons
const Icons = {
  Back: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  ),
  Save: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
      <polyline points="17 21 17 13 7 13 7 21" />
      <polyline points="7 3 7 8 15 8" />
    </svg>
  ),
  Cancel: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Spinner: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tcf-spinner-small">
      <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
  File: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
    </svg>
  ),
  Remove: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Upload: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  ),
  Check: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round">
      <path d="M20 6L9 17L4 12" />
    </svg>
  ),
  Clock: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  Order: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M8 2V6M16 2V6M3 10H21" />
    </svg>
  ),
  Text: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 7V4h16v3" />
      <line x1="9" y1="20" x2="15" y2="20" />
      <line x1="12" y1="4" x2="12" y2="20" />
    </svg>
  ),
  Video: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="2.18" />
      <line x1="8" y1="2" x2="8" y2="22" />
      <line x1="16" y1="2" x2="16" y2="22" />
      <line x1="2" y1="8" x2="22" y2="8" />
      <line x1="2" y1="16" x2="22" y2="16" />
    </svg>
  ),
  Quiz: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 7L12 12L22 7L12 2Z" />
      <path d="M2 17L12 22L22 17" />
      <path d="M2 12L12 17L22 12" />
    </svg>
  ),
  Assignment: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
    </svg>
  ),
};

const TrainingContentForm: React.FC = () => {
  const { contentId } = useParams<{ contentId: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [existingAttachments, setExistingAttachments] = useState<any[]>([]);
  
  const moduleIdFromParams = useParams<{ moduleId: string }>().moduleId;
  const moduleIdFromQuery = searchParams.get('moduleId');
  const moduleId = moduleIdFromParams || moduleIdFromQuery;
  
  const [currentModuleId, setCurrentModuleId] = useState<number | null>(null);
  
  const [formData, setFormData] = useState({
    content_type: 'text',
    title: '',
    content: '',
    order: 0,
    duration_minutes: 15,
    time_limit_minutes: null as number | null,
  });

  const isEditing = contentId && contentId !== 'new' && contentId !== undefined;
  const parsedContentId = isEditing ? parseInt(contentId, 10) : null;

  useEffect(() => {
    if (moduleId) {
      const parsed = parseInt(moduleId, 10);
      if (!isNaN(parsed)) {
        setCurrentModuleId(parsed);
      } else {
        setError('Invalid module ID');
      }
    }
    
    if (isEditing && parsedContentId && !isNaN(parsedContentId)) {
      fetchContent();
    } else if (!moduleId) {
      setError('Module ID is required');
    }
  }, [contentId, moduleId]);

  const fetchContent = async () => {
    try {
      setFetching(true);
      const response = await adminTrainingAPI.getContent(parsedContentId!);
      
      const content = response.data;
      setFormData({
        content_type: content.content_type,
        title: content.title,
        content: content.content || '',
        order: content.order,
        duration_minutes: content.duration_minutes,
        time_limit_minutes: content.time_limit_minutes || null,
      });
      
      if (content.attachments && Array.isArray(content.attachments)) {
        setExistingAttachments(content.attachments);
      }
    } catch (error: any) {
      console.error('Error fetching content:', error);
      setError(`Failed to load content: ${error.response?.data?.message || error.message}`);
    } finally {
      setFetching(false);
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      setUploadedFiles(prev => [...prev, ...files]);
    }
  };

  const removeFile = (index: number) => {
    setUploadedFiles(prev => prev.filter((_, i) => i !== index));
  };

  const removeExistingAttachment = async (attachmentId: number) => {
    if (window.confirm('Are you sure you want to remove this attachment?')) {
      try {
        await adminTrainingAPI.deleteAttachment(attachmentId);
        setExistingAttachments(prev => prev.filter(att => att.id !== attachmentId));
        alert('Attachment removed successfully');
      } catch (error) {
        console.error('Error removing attachment:', error);
        alert('Failed to remove attachment');
      }
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      const submitData = new FormData();
      submitData.append('content_type', formData.content_type);
      submitData.append('title', formData.title);
      submitData.append('content', formData.content || '');
      submitData.append('order', formData.order.toString());
      submitData.append('duration_minutes', formData.duration_minutes.toString());
      
      if (formData.time_limit_minutes) {
        submitData.append('time_limit_minutes', formData.time_limit_minutes.toString());
      }
      
      if (uploadedFiles.length > 0) {
        uploadedFiles.forEach((file) => {
          submitData.append('uploaded_files', file);
        });
      }
      
      let response;
      if (isEditing && parsedContentId && !isNaN(parsedContentId)) {
        response = await adminTrainingAPI.updateContent(parsedContentId, submitData);
        alert('Content updated successfully!');
      } else {
        if (!currentModuleId) {
          throw new Error('Module ID is required to create content');
        }
        response = await adminTrainingAPI.createContent(currentModuleId, submitData);
        alert('Content created successfully!');
      }
      
      if (currentModuleId) {
        navigate(`/dashboard/admin/training/modules/${currentModuleId}/contents`);
      } else if (moduleId) {
        navigate(`/dashboard/admin/training/modules/${moduleId}/contents`);
      } else {
        navigate('/dashboard/admin/training/modules');
      }
    } catch (error: any) {
      console.error('Error saving content:', error);
      
      let errorMsg = 'Failed to save content';
      if (error.response?.data) {
        if (typeof error.response.data === 'object') {
          const errors = error.response.data;
          const errorMessages = [];
          for (const key in errors) {
            if (Array.isArray(errors[key])) {
              errorMessages.push(`${key}: ${errors[key].join(', ')}`);
            } else if (typeof errors[key] === 'string') {
              errorMessages.push(`${key}: ${errors[key]}`);
            }
          }
          errorMsg = errorMessages.join('; ');
        } else {
          errorMsg = error.response.data.message || error.response.data.error || errorMsg;
        }
      } else if (error.message) {
        errorMsg = error.message;
      }
      
      setError(errorMsg);
      alert(`Failed to save content: ${errorMsg}`);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    if (currentModuleId) {
      navigate(`/dashboard/admin/training/modules/${currentModuleId}/contents`);
    } else if (moduleId) {
      navigate(`/dashboard/admin/training/modules/${moduleId}/contents`);
    } else {
      navigate('/dashboard/admin/training/modules');
    }
  };

  const getContentTypeIcon = (type: string) => {
    switch(type) {
      case 'video': return <Icons.Video />;
      case 'text': return <Icons.Text />;
      case 'quiz': return <Icons.Quiz />;
      case 'assignment': return <Icons.Assignment />;
      default: return <Icons.Text />;
    }
  };

  const getContentTypeLabel = (type: string) => {
    switch(type) {
      case 'video': return 'Video Lesson';
      case 'text': return 'Text Lesson';
      case 'quiz': return 'Quiz';
      case 'assignment': return 'Assignment';
      default: return 'Content';
    }
  };

  if (fetching) {
    return (
      <div className="tcf-loading-container">
        <div className="tcf-spinner">
          <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tcf-spinner-svg">
            <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
          </svg>
        </div>
        <p className="tcf-loading-text">Loading content...</p>
      </div>
    );
  }

  return (
    <div className="tcf-container">
      {/* Header */}
      <div className="tcf-header">
        <div className="tcf-header-left">
          <button className="tcf-back-btn" onClick={handleCancel}>
            <Icons.Back />
            Back to Contents
          </button>
          <h1 className="tcf-title">{isEditing ? 'Edit Content' : 'Create New Content'}</h1>
        </div>
        <button className="tcf-btn-secondary" onClick={handleCancel}>
          <Icons.Cancel />
          Cancel
        </button>
      </div>

      {/* Error Message */}
      {error && (
        <div className="tcf-error-alert">
          <span className="tcf-error-icon">⚠️</span>
          <span className="tcf-error-text">{error}</span>
        </div>
      )}

      {/* Form */}
      <form onSubmit={handleSubmit} className="tcf-form">
        <div className="tcf-form-grid">
          {/* Left Column */}
          <div className="tcf-form-left">
            <div className="tcf-card">
              <h3 className="tcf-card-title">Content Information</h3>
              
              <div className="tcf-form-group">
                <label className="tcf-form-label">Content Type *</label>
                <select
                  className="tcf-form-select"
                  value={formData.content_type}
                  onChange={(e) => setFormData({ ...formData, content_type: e.target.value })}
                  disabled={!!isEditing}
                >
                  <option value="text">📖 Text Lesson</option>
                  <option value="video">🎥 Video Lesson</option>
                  <option value="quiz">📝 Quiz</option>
                  <option value="assignment">✏️ Assignment</option>
                </select>
                {isEditing && (
                  <span className="tcf-form-hint">Content type cannot be changed after creation</span>
                )}
              </div>

              <div className="tcf-form-group">
                <label className="tcf-form-label">Title *</label>
                <input
                  type="text"
                  className="tcf-form-input"
                  required
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  placeholder="Enter content title"
                />
              </div>

              <div className="tcf-form-group">
                <label className="tcf-form-label">
                  {formData.content_type === 'text' && 'Content / Notes'}
                  {formData.content_type === 'video' && 'Video URL *'}
                  {formData.content_type === 'quiz' && 'Quiz Questions *'}
                  {formData.content_type === 'assignment' && 'Assignment Details *'}
                </label>
                
                {formData.content_type === 'text' && (
                  <>
                    <textarea
                      className="tcf-form-textarea tcf-form-textarea-large"
                      rows={12}
                      value={formData.content}
                      onChange={(e) => setFormData({ ...formData, content: e.target.value })}
                      placeholder="Write your lesson notes here. You can also upload documents below."
                    />
                    <span className="tcf-form-hint">Write your own notes. You can also upload documents below.</span>
                  </>
                )}
                
                {formData.content_type === 'video' && (
                  <input
                    type="url"
                    className="tcf-form-input"
                    required
                    value={formData.content}
                    onChange={(e) => setFormData({ ...formData, content: e.target.value })}
                    placeholder="https://www.youtube.com/watch?v=VIDEO_ID"
                  />
                )}
                
                {formData.content_type === 'quiz' && (
                  <textarea
                    className="tcf-form-textarea tcf-form-textarea-large"
                    required
                    rows={12}
                    value={formData.content}
                    onChange={(e) => setFormData({ ...formData, content: e.target.value })}
                    placeholder="Enter quiz questions and answers..."
                  />
                )}
                
                {formData.content_type === 'assignment' && (
                  <textarea
                    className="tcf-form-textarea tcf-form-textarea-large"
                    required
                    rows={12}
                    value={formData.content}
                    onChange={(e) => setFormData({ ...formData, content: e.target.value })}
                    placeholder="Enter assignment details..."
                  />
                )}
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="tcf-form-right">
            {/* Settings */}
            <div className="tcf-card">
              <h3 className="tcf-card-title">Settings</h3>
              
              <div className="tcf-form-group">
                <label className="tcf-form-label">
                  <Icons.Order />
                  Display Order
                </label>
                <input
                  type="number"
                  className="tcf-form-input"
                  min="0"
                  value={formData.order}
                  onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) || 0 })}
                />
                <span className="tcf-form-hint">Lower numbers appear first</span>
              </div>

              <div className="tcf-form-group">
                <label className="tcf-form-label">
                  <Icons.Clock />
                  Duration (minutes)
                </label>
                <input
                  type="number"
                  className="tcf-form-input"
                  min="1"
                  value={formData.duration_minutes}
                  onChange={(e) => setFormData({ ...formData, duration_minutes: parseInt(e.target.value) || 15 })}
                />
                <span className="tcf-form-hint">Estimated time to complete</span>
              </div>

              {(formData.content_type === 'quiz' || formData.content_type === 'assignment') && (
                <div className="tcf-form-group">
                  <label className="tcf-form-label">
                    <Icons.Clock />
                    Time Limit (minutes) *
                  </label>
                  <input
                    type="number"
                    className="tcf-form-input"
                    min="1"
                    required
                    value={formData.time_limit_minutes || ''}
                    onChange={(e) => setFormData({ ...formData, time_limit_minutes: parseInt(e.target.value) || null })}
                    placeholder="e.g., 30"
                  />
                  <span className="tcf-form-hint">
                    Students must complete this {formData.content_type} within this time limit
                  </span>
                </div>
              )}
            </div>

            {/* File Upload */}
            {formData.content_type === 'text' && (
              <div className="tcf-card">
                <h3 className="tcf-card-title">
                  <Icons.Upload />
                  Upload Documents
                </h3>
                
                <div className="tcf-file-upload">
                  <input
                    type="file"
                    id="file-upload"
                    multiple
                    accept=".docx,.pdf,.txt"
                    onChange={handleFileChange}
                    className="tcf-file-input"
                  />
                  <label htmlFor="file-upload" className="tcf-file-label">
                    <Icons.Upload />
                    <span>Click to upload documents</span>
                    <span className="tcf-file-hint">DOCX, PDF, TXT (Max 10MB each)</span>
                  </label>
                </div>
                
                {uploadedFiles.length > 0 && (
                  <div className="tcf-uploaded-files">
                    <h4 className="tcf-uploaded-title">New Documents ({uploadedFiles.length})</h4>
                    {uploadedFiles.map((file, index) => (
                      <div key={index} className="tcf-file-item">
                        <span className="tcf-file-item-name">
                          <Icons.File />
                          {file.name}
                        </span>
                        <span className="tcf-file-item-size">
                          {(file.size / 1024).toFixed(2)} KB
                        </span>
                        <button 
                          type="button" 
                          onClick={() => removeFile(index)} 
                          className="tcf-file-remove"
                        >
                          <Icons.Remove />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
                
                {existingAttachments.length > 0 && (
                  <div className="tcf-existing-files">
                    <h4 className="tcf-existing-title">Existing Documents ({existingAttachments.length})</h4>
                    {existingAttachments.map((attachment) => (
                      <div key={attachment.id} className="tcf-file-item">
                        <span className="tcf-file-item-name">
                          <Icons.File />
                          {attachment.file_name}
                        </span>
                        <span className="tcf-file-item-size">
                          {(attachment.file_size / 1024).toFixed(2)} KB
                        </span>
                        {attachment.extracted_text && (
                          <span className="tcf-file-extracted">
                            <Icons.Check />
                            Text extracted
                          </span>
                        )}
                        <button 
                          type="button" 
                          onClick={() => removeExistingAttachment(attachment.id)} 
                          className="tcf-file-remove"
                        >
                          <Icons.Remove />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Actions */}
        <div className="tcf-form-actions">
          <button 
            type="button" 
            className="tcf-btn-secondary" 
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className="tcf-btn-primary" 
            disabled={loading}
          >
            {loading ? (
              <>
                <Icons.Spinner />
                Saving...
              </>
            ) : (
              <>
                <Icons.Save />
                {isEditing ? 'Update Content' : 'Create Content'}
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default TrainingContentForm;